<template>
    <div class="page forgot-pass-page">
        <div class="page-wrap">
            <img src="@/assets/authorization/password.png" class="img-password"/>

            <div class="form-wrap">
                <div class="form-content">
                    <header-main>
                        {{ $t("components.authorization.forgotpass.header") }}
                    </header-main>

                    <form
                        id="forgot-password-form"
                        novalidate
                        @keydown.enter.prevent="forgotPassword"
                    >
                        <p>
                            {{ $t("components.authorization.forgotpass.text") }}
                        </p>
                        <div
                            :class="[
                'input-wrap',
                { input_error: v$.form.email.$errors.length },
              ]"
                        >
                            <input-field
                                v-model="v$.form.email.$model"
                                type="email"
                                :placeholder="$t('components.authorization.mail')"
                            />
                            <div
                                class="input-errors"
                                :style="{ height: v$.form.email.$errors.length ? '14px' : 0 }"
                            >
                <span
                    v-for="(error, index) of v$.form.email.$errors"
                    :key="index"
                >
                  {{ $t(`components.authorization.${error.$message}`) }}
                </span>
                            </div>
                        </div>
                    </form>

                    <button-loading
                        class="btn"
                        type="submit"
                        form="forgot-password-form"
                        :loading="button.loading"
                        :disabled="button.disabled"
                        @click.prevent="forgotPassword"
                    >
                        {{ $t("components.authorization.forgotpass.button") }}
                    </button-loading>

                    <router-link :to="{ name: 'SignIn' }" class="bottom-link mt-2">
                        {{ $t("components.authorization.forgotpass.link") }}
                    </router-link>

                    <LanguageSelect/>

                    <auth-landing-link/>
                </div>

                <img src="@/assets/authorization/wave.svg" class="wave"/>

                <img src="@/assets/authorization/ronm-bg.png" class="ronm-bg"/>

                <img src="@/assets/authorization/cilinder-bf.png" class="cilinder-bf"/>
            </div>
        </div>
    </div>
</template>

<script>
import ButtonLoading from "@/components/Recurring/ButtonLoading.vue";
import InputField from "@/components/Recurring/InputField.vue";
import HeaderMain from "@/components/Recurring/HeaderMain.vue";
import AuthLandingLink from "@/components/Auth/AuthLandingLink.vue";
import LanguageSelect from "@/components/Recurring/LanguageSelect.vue";
import ToastContent from "@/components/Recurring/ToastContent.vue";

import {mapActions} from "vuex";
import {withProps, clearToasts} from "mosha-vue-toastify";

import useVuelidate from "@vuelidate/core";
import {
    required,
    email,
    minLength,
    sameAs,
    helpers,
} from "@vuelidate/validators";

export default {
    name: "ForgotPassPage",

    components: {
        ButtonLoading,
        InputField,
        HeaderMain,
        AuthLandingLink,
        LanguageSelect,
        ToastContent,
    },

    setup() {
        return {v$: useVuelidate(), clearToasts};
    },

    data() {
        return {
            form: {
                email: "",
            },

            button: {
                loading: false,
                disabled: false,
            },
        };
    },

    validations() {
        return {
            form: {
                email: {
                    required: helpers.withMessage("required", required),
                    email: helpers.withMessage("email_invalid_error", email),
                },
            },
        };
    },

    methods: {
        ...mapActions("auth", ["FORGOT_PASSWORD"]),

        setBtnLoading() {
            if (this.button.loading) {
                this.button.loading = false;
                this.button.disabled = false;

                return;
            }

            this.button.loading = true;
            this.button.disabled = true;
        },

        async forgotPassword() {
            const isFormCorrect = await this.v$.$validate();

            if (!isFormCorrect) return;

            const payload = {
                email: this.form.email,
            };

            this.setBtnLoading();

            await this.FORGOT_PASSWORD(payload)
                .then(() => {
                    this.$moshaToast(
                        withProps(ToastContent, {
                            msg: this.$t("components.authorization.final.header"),
                            type: "success",
                        }),
                        {
                            hideProgressBar: true,
                        }
                    );
                })
                .catch((error) => {
                    let toastMsg = this.$t(
                        "components.authorization.forgotpass.toast_error"
                    );

                    let responseMsg = error?.response?.data?.description;

                    if (responseMsg === "Account not found") {
                        toastMsg = this.$t(
                            "components.authorization.forgotpass.email_not_exists_error"
                        );
                    }

                    this.$moshaToast(
                        withProps(ToastContent, {
                            msg: toastMsg,
                            type: "error",
                        }),
                        {
                            hideProgressBar: true,
                            timeout: 10000,
                        }
                    );
                })
                .finally(() => this.setBtnLoading());
        },
    },

    unmounted() {
        this.clearToasts();
    },
};
</script>

<style lang="scss" scoped>
@use "@/styles/pages/auth/auth.scss";

.form-content {
    // min-height: the card grows with the "Go to the E-chat website" link instead of squeezing the button
    min-height: 355px;
    background: rgba(#ffffff, 0.67) !important;
}

#forgot-password-form {
    width: 100%;
}
</style>
